import React from 'react';
import { FileText, Ruler, Droplets, Weight, ChevronDown } from 'lucide-react';

const AccordionItem = ({ icon, label, value }) => (
    <details className="group border-b border-white/10 last:border-0">
        <summary className="flex items-center justify-between cursor-pointer py-3 text-base font-medium dark:text-white text-gray-900 list-none [&::-webkit-details-marker]:hidden select-none">
            <span className="flex items-center gap-2 text-gray-700 dark:text-gray-200">
                {icon}
                {label}
            </span>
            <ChevronDown
                size={16}
                className="opacity-50 transition-transform duration-200 group-open:rotate-180 flex-shrink-0"
            />
        </summary>
        <div className="pt-1 pb-4 text-gray-500 dark:text-gray-400 text-sm leading-relaxed">
            {value || <span className="italic opacity-60">No especificado</span>}
        </div>
    </details>
);

const DetallesProducto = ({ product }) => (
    <div className="p-6">
        <h2 className="text-2xl font-bold dark:text-white text-gray-900 mb-4">Detalles del producto</h2>

        <AccordionItem
            icon={<FileText size={16} />}
            label="Descripción completa"
            value={product?.description}
        />
        <AccordionItem
            icon={<Ruler size={16} />}
            label="Dimensiones"
            value={product?.dimensions}
        />
        <AccordionItem
            icon={<Droplets size={16} />}
            label="Materiales"
            value={product?.materials}
        />
        <AccordionItem
            icon={<Weight size={16} />}
            label="Peso"
            value={product?.weight}
        />
    </div>
);

export default DetallesProducto;
